import { useEffect, useRef, useState } from 'react';
import Skeleton from '@/common/components/skeleton/Skeleton';
import useImageLoader, { normalizeFileId } from '@/common/hooks/useImage';
import {
	StoryButton,
	StoryName,
	StoryRing,
	StoryRingMedia,
	StoryRingImage,
} from '../storiesBar.styles';

const StoryAvatar = ({ person, onOpen }) => {
	const profileMediaId = normalizeFileId(
		person?.profile_image?._id ?? person?.profile_image,
	);
	const { imageSrc, isLoading } = useImageLoader(profileMediaId);
	const [isImageLoaded, setIsImageLoaded] = useState(false);
	const [hasImageError, setHasImageError] = useState(false);
	const imageRef = useRef(null);

	const isFileReady = !profileMediaId || !isLoading;
	const showImageSkeleton =
		!isFileReady || !imageSrc || hasImageError || !isImageLoaded;

	useEffect(() => {
		setIsImageLoaded(false);
		setHasImageError(false);
	}, [imageSrc]);

	useEffect(() => {
		const element = imageRef.current;

		if (!element || !imageSrc || hasImageError) {
			return;
		}

		if (element.complete && element.naturalWidth > 0) {
			setIsImageLoaded(true);
		}
	}, [imageSrc, hasImageError]);

	const handleImageLoad = () => {
		setIsImageLoaded(true);
		setHasImageError(false);
	};

	const handleImageError = () => {
		setIsImageLoaded(false);
		setHasImageError(true);
	};

	return (
		<StoryButton
			type="button"
			onClick={() => onOpen(person._id || person.id)}
		>
			<StoryRing>
				<StoryRingMedia>
					{showImageSkeleton && (
						<Skeleton
							width="100%"
							height="100%"
							radius="50%"
							minWidth="100%"
							minHeight="100%"
						/>
					)}
					{imageSrc && !hasImageError && (
						<StoryRingImage
							ref={imageRef}
							src={imageSrc}
							alt={person.name}
							$visible={isImageLoaded}
							onLoad={handleImageLoad}
							onError={handleImageError}
						/>
					)}
				</StoryRingMedia>
			</StoryRing>
			<StoryName>{person.name}</StoryName>
		</StoryButton>
	);
};

export default StoryAvatar;
